import React from 'react'
import { useSelector } from 'react-redux'

import { Typography } from '@material-ui/core'

import { translatePermission } from 'utils/constants/user'

export default function () {
  const user = useSelector((state) => state.user)

  const renderUserEmail = (userEmail) => {
    return (
      <Typography>
        <span>Email:</span>
        {' '}
        <strong>{userEmail}</strong>
      </Typography>
    )
  }

  const renderUserPermission = (userPermission) => {
    return (
      <Typography>
        <span>Permissão:</span>
        {' '}
        <strong>{translatePermission(userPermission)}</strong>
      </Typography>
    )
  }

  return (
    <div>
      {renderUserEmail(user.email)}
      {renderUserPermission(user.permission)}
    </div>
  )
}
